import { useEffect, useRef } from 'react';
export default function useManageHoverEvents(hoverTargetElement, focused) {
    useEffect(() => {
        if (!hoverTargetElement)
            return undefined;
        const onHoverStart = () => {
            hoverTargetElement.dispatchEvent(new Event('hvp:hoverStart'));
        };
        const onHoverEnd = () => {
            hoverTargetElement.dispatchEvent(new Event('hvp:hoverEnd'));
        };
        hoverTargetElement.addEventListener('mouseenter', onHoverStart);
        hoverTargetElement.addEventListener('mouseleave', onHoverEnd);
        hoverTargetElement.addEventListener('focus', onHoverStart);
        hoverTargetElement.addEventListener('blur', onHoverEnd);
        const touchStartListenerOptions = { passive: true };
        hoverTargetElement.addEventListener('touchstart', onHoverStart, touchStartListenerOptions);
        const onWindowTouchStart = (event) => {
            if (!(event.target instanceof Node) ||
                !hoverTargetElement.contains(event.target)) {
                onHoverEnd();
            }
        };
        window.addEventListener('touchstart', onWindowTouchStart, touchStartListenerOptions);
        return () => {
            hoverTargetElement.removeEventListener('mouseenter', onHoverStart);
            hoverTargetElement.removeEventListener('mouseleave', onHoverEnd);
            hoverTargetElement.removeEventListener('focus', onHoverStart);
            hoverTargetElement.removeEventListener('blur', onHoverEnd);
            hoverTargetElement.removeEventListener('touchstart', onHoverStart);
            window.removeEventListener('touchstart', onWindowTouchStart);
        };
    }, [hoverTargetElement]);
    const previousFocusedRef = useRef(false);
    useEffect(() => {
        if (!hoverTargetElement)
            return;
        if (previousFocusedRef.current !== focused) {
            previousFocusedRef.current = focused;
            if (focused) {
                hoverTargetElement.dispatchEvent(new Event('hvp:hoverStart'));
            }
            else {
                hoverTargetElement.dispatchEvent(new Event('hvp:hoverEnd'));
            }
        }
    }, [hoverTargetElement, focused]);
}
